import styled from "styled-components"
import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import Tooltip from '@mui/material/Tooltip';
import api from '../../../../axios.js'
import ReventaConfigPrices from "./reventaConfigPrices.jsx"


let Container=styled.div`
	display:flex;
	width:100%;
	position:relative
`;

let ContainerReventaPrices=styled.div`
	position:absolute;
	height:100%;
	width:100%
`;


export default function AvailableAccounts(props){
	let {accounts,userId,consola,tipoCuenta,setOpen}=props;
	let  [load,setLoad]=React.useState(false);
	let  [reventaSave,setReventaSave]=React.useState();

	console.log(reventaSave)

	let save=async(gameId,Cuenta_juegoId,accountId)=>{

		if(!load){

			if ( window.confirm("deseas agregar este juego?") ){
				setLoad(true);
				try{
					let response = await api.post(`/usuario/addGame?idUser=${userId}&cuenta=${accountId}&cuentajuego=${Cuenta_juegoId}&tipoCuenta=${tipoCuenta}`);					
					alert("datos agregados");
					console.log(response);
					if(window.confirm("desea publicar como reventa?")){
						await setReventaSave(response.data);
					}else{
						setLoad(false);
						setOpen(false);
					}			
				}catch (err){
					console.error(err);
					setLoad(false);
					alert("error al grabar los datos")
				};
				
			}
		}else{ alert("asignacion en proceso") }	
	}



	function formatFecha(fecha) {
  return new Date(fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
	return(
		<Container>
			{reventaSave?<ContainerReventaPrices><ReventaConfigPrices setLoad={setLoad} setOpen={setOpen} reventa={reventaSave} setReventaSave={setReventaSave}/></ContainerReventaPrices>:null}
			<TableContainer >
        		<Table stickyHeader aria-label="sticky table">
          			<TableHead>
            			<TableRow>
              				<TableCell align="center" colSpan={4}>
                				Cuentas
              				</TableCell>
              				<TableCell align="center" colSpan={1}>
                				juegos
              				</TableCell>
              				<TableCell>
              				</TableCell>
            			</TableRow>
            			<TableRow>
            				<TableCell align="center">
                				Id
              				</TableCell>
              				<TableCell align="center">
                				Playstation id
              				</TableCell>
              				<TableCell align="center">
                				Correo
              				</TableCell>
              				<TableCell align="center">
                				Fecha creacion
              				</TableCell>
              				<TableCell align="center">
                				Id
              				</TableCell>
              				<TableCell>
              					agregar
              				</TableCell>
            			</TableRow>
          			</TableHead>
          			<TableBody>
          				{accounts.map(account=>
          					<TableRow key={account.id}>
          						<TableCell>
          							{account.Cuentum.id}
          						</TableCell>
          						<TableCell>
          							{account.Cuentum.playstation_id}
          						</TableCell>
          						<TableCell>
          							{account.Cuentum.correo}
          						</TableCell>
          						<TableCell>
          							{formatFecha(account.createdAt)}
          						</TableCell>
          						<TableCell>
          							{account.id}
          						</TableCell>
          						<TableCell>
          							<Tooltip title="Agregar a cuenta"> 
          								<PlaylistAddIcon onClick={()=>save(account.juegoId,account.id,account.Cuentum.id)} />
          							</Tooltip>
              					</TableCell>
          					</TableRow>
						)}
           
          			</TableBody>
        		</Table>
      		</TableContainer>      
		</Container>
		)



}